import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  ListBanksUseCasePort
} from '@features/setting/application/use_cases/list-banks/list-banks.use-case.port';
import {
  ListBanksPayloadDto
} from '@features/setting/application/use_cases/list-banks/dto/list-banks.payload.dto';
import {
  ListBanksResponseDto
} from '@features/setting/application/use_cases/list-banks/dto/list-banks.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {
  ListBanksHttpPayloadDto
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.payload.dto';
import {
  ListBanksHttpResponseDto
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.response.dto';
import {
  ListBanksHttpMapper
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.mapper';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';

@Injectable()
export class ListBanksHttpAdapter implements ListBanksUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort: LocalStoragePort = inject(LocalStoragePort);

  public execute(payload: ListBanksPayloadDto): Observable<ListBanksResponseDto> {
    const suffix: string | null = this.localStoragePort.getByKey("_suffix");
    return this.http.get<ListBanksHttpResponseDto>(`${this.url}bank-account-list?suffix_database=${suffix}`, ListBanksHttpMapper.toInfra(payload))
      .pipe(map(ListBanksHttpMapper.toResponse)
      )
  }

}
